export default "__VITE_ASSET__BjpEbskj__"